import { render } from "./Amount.vue?vue&type=template&id=40156c0d&scoped=true"
import script from "./Amount.vue?vue&type=script&lang=js"
export * from "./Amount.vue?vue&type=script&lang=js"

import "./Amount.vue?vue&type=style&index=0&id=40156c0d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40156c0d"],['__file',"src/components/Input/Amount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40156c0d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40156c0d', __exports__)) {
    api.reload('40156c0d', __exports__)
  }
  
  module.hot.accept("./Amount.vue?vue&type=template&id=40156c0d&scoped=true", () => {
    api.rerender('40156c0d', render)
  })

}


export default __exports__